/*
 * Copyright (c) Nexign, JSC, 2019-2024.
 */
/**
 *
 * @author Yakov Gushchin
 * @author Aleksandr Perkhunov
 * @author Evgenij Tyan
 * @author Misha Kokoulin
 * @author Maxim Fedorov
 * @author Anton Panasenko
 * @author Evgeniy Naumov
 * @author Ilya Baranchikov
 * @author Nikolay Sviridov
 * @version 1.32.0
 * @since 1.0.0
 */

import { ICommonTranslation } from '../../types';
import initTranslationCorporate from '../corporate';
import initTranslationAccountSelect from './accountSelect';
import initTranslationBasket from './basket';
import initTranslationCalendar from './calendar';
import initTranslationCollapse from './collapse';
import initTranslationContextHelp from './contextHelp';
import initTranslationDropdown from './dropdown';
import initTranslationEmailInput from './emailInput';
import { initTranslationError } from './error';
import initTranslationExport from './export';
import initTranslationFooter from './footer';
import initTranslationHeader from './header';
import initTranslationLists from './lists';
import initTranslationMultiSelect from './multiSelect';
import { initTranslationNotification } from './notification';
import { initTranslationPages } from './pages';
import initTranslationPhoneInput from './phoneInput';
import initTranslationRange from './range';
import { initialReportSchedule } from './reportSchedule';
import initTranslationSearchInput from './searchInput';
import initTranslationSelect from './select';
import initTranslationTable from './table';
import initTranslationWidget from './widget';

const initTranslationCommon: ICommonTranslation = {
    ...initTranslationCorporate,
    aboutLink: '',
    accountSelect: initTranslationAccountSelect,
    basket: initTranslationBasket,
    banner: {
        learnMore: '',
        moreDetails: '',
    },
    bizLink: '',
    brandText: {
        copyright: '',
    },
    browserWarning: {
        title: '',
        html: '',
    },
    calendar: initTranslationCalendar,
    collapse: initTranslationCollapse,
    commonTable: initTranslationTable,
    commonWidget: initTranslationWidget,
    companyInfoPhone: '',
    contextHelp: initTranslationContextHelp,
    contextHelpLink: '',
    currency: '',
    dataSync: '',
    dropDown: initTranslationDropdown,
    emailInput: initTranslationEmailInput,
    error: initTranslationError,
    export: initTranslationExport,
    footer: initTranslationFooter,
    header: initTranslationHeader,
    lists: initTranslationLists,
    menu: '',
    minutes: '',
    multiSelect: initTranslationMultiSelect,
    notification: initTranslationNotification,
    pages: initTranslationPages,
    passwordInput: { hint: '' },
    phoneInput: initTranslationPhoneInput,
    range: initTranslationRange,
    reportSchedule: initialReportSchedule,
    route: '',
    scores: '',
    searchInput: initTranslationSearchInput,
    seconds: '',
    secondsFrom: '',
    byte: '',
    kilobyte: '',
    megabyte: '',
    select: initTranslationSelect,
    serviceUser: {
        notificationGoToLabel: '',
        tooltip: '',
    },
    usernamePrefix: '',
    orderCreationModal: {
        success: {
            title: {
                one: '',
                few: '',
            },
            order: '',
            orderNumber: '',
            orderSeparator: {
                and: '',
                comma: '',
            },
            ordersStatusLink: '',
            ordersStatusText: '',
            ordersStatusLinkMegaPowers: '',
            orderStatusTextMegaPowers: '',
            orderType: {
                RATE_PLAN_ACTIVATE: '',
                MEGA_POWERS_ACTIVATE: '',
                MEGA_POWERS_DEACTIVATE: '',
                SERVICE_ACTIVATE: '',
                SERVICE_DEACTIVATE: '',
                CALLS_DETAIL_REPORT: '',
                LOCK_ACTIVATE: '',
                LOCK_DEACTIVATE: '',
                LOCK: '',
                CLIENT_EXPENSES_REPORT: '',
                LABELS_IMPORT: '',
                MONEY_TRANSFER: '',
                ADDITIONAL_ACCOUNTS_ACTIVATE: '',
                ADDITIONAL_ACCOUNTS_DEACTIVATE: '',
                ADDITIONAL_ACCOUNTS: '',
                PERSONAL_DATA_IMPORT: '',
                PERSONAL_DATA_DELETE: '',
                COLLATION_REPORT: '',
                IMPORT_SUBSCRIBERS_LIMITS: '',
                CHANGE_ROLE: '',
            },
            orderCreated: {
                one: '',
                few: '',
            },
            buttons: {
                goToMain: '',
            },
        },
    },
};

export default initTranslationCommon;
